import script from "./TableCommandes.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableCommandes.vue?vue&type=script&setup=true&lang=ts"

import "./TableCommandes.vue?vue&type=style&index=0&id=0b88bac8&lang=scss"

const __exports__ = script;

export default __exports__